import {
  Component, OnInit,
  Input, Output, EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { ResourceService } from 'app/_service/resource/resource.service';

@Component({
  selector: 'you-chat-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  contacts$;

  @Input()
  selectedUser;

  @Output()
  onSelectUser = new EventEmitter();

  @Output()
  onRemoveUser = new EventEmitter();

  @Input()
  fromSticky = false;

  constructor(
    private socketFacade: SocketFacade,
    public _resourceService: ResourceService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) { }

  ngOnInit() {
    this.contacts$ = this.socketFacade.contacts$;
    // this.socketFacade.contacts$.subscribe(p=>{
    //   console.log("change",p)
    // })
  }

  selectUser(user) {
    if (this.selectedUser?.id !== user.id) {
      this.onSelectUser.emit(user);
      const urlChanged = this._router.createUrlTree(
        [],
        {
          relativeTo: this._activatedRoute,
          queryParams: {
            id: this.fromSticky ? null : user.id, // 聊天小窗口时不调整url参数
          },
        }
      ).toString();
      this._router.navigateByUrl(urlChanged,{
        replaceUrl:true
      });
    }
  }

  removeContact(contact) {
    this.socketFacade.RemoveContact(contact.id);
    this.onRemoveUser.emit();
  }

  getMembership(gid) {
    let membership = '';
    switch (gid) {
      case 0:
        membership = '';
        break;
      case 1:
        membership = 'gvip';
        break;
      case 2:
        membership = 'gvip';
        break;
      case 3:
        membership = 'royalVip';
        break;
      case 4:
        membership = 'cpvip';
        break;
      case 101:
        membership = 'cpvip';
        break;
      case 102:
        membership = 'cpvip';
        break;
      default:
        membership = 'vip';
    }
    return membership;
  }
}
